import {Avatar, Button, Card, Col, Form, message, Modal, Row, Switch, InputNumber, Input, Icon} from "antd";
import {observer} from "mobx-react";
import React from "react";
import agent_detail_pay_store from '@store/Agent/AgentDetailPayStore';
import {action, observable, runInAction} from "mobx";
import {form_item_size} from '@common/theme';
import fetchUrl from '@service/fetchUrl';
import service from '@service/index';

const CardMeta = Card.Meta;
const FormItem = Form.Item;

@Form.create()
@observer
class AgentDetailPayModal extends React.Component {
  @observable
  submitting = false;

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        runInAction(() => {
          this.submitting = true;
        });
        let result = await service.fetchData({
          path: fetchUrl.agent.payMoney,
          params: {
            username: agent_detail_pay_store.record.nick_name,
            is_proxy: agent_detail_pay_store.record.is_proxy,
            money: values.money,
            pwd: values.payPassword
          }
        });
        runInAction(() => {
          this.submitting = false;
        });
        if (result.success) {
          message.success('充值成功.', 3);
          this.resetFormValue();
          agent_detail_pay_store.record.balance = result.data.balance;
          agent_detail_pay_store.callSuccess(agent_detail_pay_store.record);

        } else {
          message.error(`充值修改失败. ${ result.error.error_data }`, 3);
        }
      }
    });
  };

  @observable
  password_input_type = 'password';

  @action
  togglePasswordInputType = () => {
    this.password_input_type = this.password_input_type === 'password' ? 'text' : 'password';
  };

  resetFormValue = e => {
    this.props.form.resetFields();
  }

  constructor() {
    super();
    this.state = {money: 0};
  }

  render() {
    let input_style = {
      width: '200px'
    };

    let row_style = {
      height:'40px',
      marginBottom: '10px'
    };

    let { getFieldDecorator } = this.props.form;

    let formItemLayout = {
      labelCol: {
        span: 6
      },
      wrapperCol: {
        span: 18
      }
    };

    return (
      <Modal
        visible={agent_detail_pay_store.is_modal_show}
        title={(
          <div>
            <span>
              代充功能
            </span>
          </div>
        )}
        maskClosable={false}
        onCancel={() => {
          this.resetFormValue();
          agent_detail_pay_store.closeModal();
        }}
        footer={null}>
        <Form onSubmit={this.handleSubmit}>
          <Card
            cover={(
              <div>
              </div>
            )}>
            <CardMeta
              description={(
                <div>
                  <Row style={row_style}>
                    <Form.Item {...formItemLayout} label='代充金额：'>
                      {
                        getFieldDecorator('money', {
                          rules: [
                          ],
                          // initialValue: 'fdawfweEQ12'
                        })(
                          <InputNumber
                            placeholder='请输入代充金额'
                            size={form_item_size}
                            style={input_style}
                            min={0}
                            step={1}/>
                        )
                      }
                    </Form.Item>

                  </Row>
                  <Row style={row_style}>
                    <Form.Item {...formItemLayout} label='输入密码：'>
                      {
                        getFieldDecorator('payPassword', {
                          rules: [
                          ],
                          // initialValue: 'fdawfweEQ12'
                        })(
                          <Input
                            placeholder='请输入支付密码'
                            size={form_item_size}
                            type={this.password_input_type}
                            style={input_style}
                            addonAfter={
                              <Icon size={form_item_size} type="eye" onClick={this.togglePasswordInputType}/>
                            }
                          />
                        )
                      }
                    </Form.Item>

                  </Row>
                  <Row style={row_style}>
                    <Form.Item
                      colon={false}
                      label=''
                    >
                    <Button size='large' htmlType="submit" block type='primary' loading={ this.submitting}>确认充值</Button>
                    </Form.Item>
                  </Row>
                </div>
              )}
              title={agent_detail_pay_store.record.pet_name}
              avatar={(
                <Avatar src={agent_detail_pay_store.record.tailor_user_url}/>
              )}/>
          </Card>
        </Form>
      </Modal>
    )
  }

  componentDidMount() {
    this.setState({someKey: 'otherValue'});
  }

  componentWillUnmount() {
  }
}

export default AgentDetailPayModal;



// WEBPACK FOOTER //
// ./src/ViewsDashboard/Agent/AgentList/AgentDetail/AgentDetailPayModal.jsx